import React from "react";
import alertImage from "../../Assets/info-circle.svg";
import "./PurchaseLimitAlertTile.scss";
import getTranslationData from "../../TranslationUtility/TranslationUtility";

const PurchaseLimitAlertTile = (props) => {
    const translatipn = getTranslationData();
   const formattedMessage = translatipn.purchase_limit_alert
   .replace("{timePeriod}", props.timePeriod)
    .replace("{amount}", props.amount)
    .replace("{name}", props.name)
    .replace("{time}", props.reset_text);
  return (
    <div className="d-flex align-items-center mt-3 p-3 monthly-limit-box">
      <img src={alertImage} alt="info" className="mr-2 purchase-limit-image" />
       <span
      className="monthly-limit-text"
      dangerouslySetInnerHTML={{ __html: formattedMessage }}
    />
    </div>
  );
};

export default PurchaseLimitAlertTile;
